import React from "react";
import { Row, Col, Input, Button, Table } from "antd";
import sortBy from "lodash/sortBy";
import { Scrollbars } from "react-custom-scrollbars";
import BackArrow from "../../../assets/images/back_arrow.svg";
import CancelArrow from "../../../assets/images/cancelArrow.svg";
import Logo from "../../../assets/images/logo-without-bg.png";
import Offers from "../../../assets/images/offers.png";
import data from "../../../constants/retailPos.json";
import { useWindowDimensions } from "../../../lib/useViewport";
import usePOSConfigStore from "../../../stores/usePOSConfigStore";

const PaymentView = ({
  paymentProcessFlag,
  cart,
  tillData,
  paymentType,
  selectedPaymentMethod,
  setSelectedPaymentMethod,
  amount,
  onChangeAmount,
  paymentModalInputRef,
  paymentCardRef,
  requestPayment,
  processOrder,
  handleAmount,
  handleKeyvalue,
  productsList,
  setProductsList,
  paymentModalLoyalityMessages,
  selectProductInCart,
  setIsSearchProducts,
  selectedRowKeys,
  selectedProductInCart,
  setIsQtyUpdate,
}) => {
  const posConfig = usePOSConfigStore((s) => s.posConfig);
  const currenciesList = tillData.tillAccess.csBunit.currencies;
  const prcPrecision = tillData?.tillAccess?.csBunit?.currencies?.[0]?.prcPrecision ?? 2;
  const { width } = useWindowDimensions();

  const handleBack = () => {
    handleKeyvalue("0");
    if (cart.items.length <= 0) {
      productsList.map((ele) => {
        ele.selected = "N";
      });
      setProductsList(productsList);
    }
  };

  if (paymentProcessFlag) {
    return (
      <div style={{ width: "100%", display: "flex" }}>
        {/* LEFT SIDE */}
        <div style={{ paddingTop: "1.8vh", width: "67.8%", backgroundColor: "#F3F4F9" }}>
          <Row style={{ paddingBottom: "2.4vh", paddingLeft: "2.3vw" }}>
            <Col span={8}>
              <img src={BackArrow} style={data.posScreenStyles.orderHistoryModal.backArrowIcon} onClick={handleBack} />
            </Col>
          </Row>

          <div style={{ width: "100%", display: "flex" }}>
            <div style={{ width: "18.5%" }} />
            <div style={{ width: "63%" }}>
              <div style={{ width: "100%", textAlign: "center", paddingBottom: "4.6vh" }}>
                <span style={data.posScreenStyles.paymentModal.cartTotalValue}>
                  {parseFloat(cart.total) < 0 ? "Change" : "Amount To Pay"}
                  {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                  &nbsp;
                  {parseFloat(cart.total) >= parseFloat(cart.paid)
                    ? parseFloat(cart.total - cart.paid).toFixed(prcPrecision)
                    : parseFloat(cart.paid - cart.total).toFixed(prcPrecision)}{" "}
                  {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                </span>
              </div>

              {/* Payment method buttons */}
              <Row gutter={[16, 16]} justify="center" align="center" style={{ height: "21vh" }}>
                {sortBy(paymentType, "sequenceNo").map((pm, ind) => {
                  return posConfig?.loyaltyApplicable === "N" && pm.name === "Loyalty" ? null : (
                    <Col span={8} style={{ width: "100%" }}>
                      <button
                        key={pm.finPaymentmethodId}
                        onClick={() => {
                          if (posConfig?.allowSplitTender === "Y") {
                            setSelectedPaymentMethod(pm);
                          } else if (cart.payments.length < 1) {
                            setSelectedPaymentMethod(pm);
                          }
                        }}
                        ref={ind === 0 ? paymentCardRef : null}
                        style={
                          pm.finPaymentmethodId === selectedPaymentMethod.finPaymentmethodId
                            ? data.posScreenStyles.paymentModal.selectedPaymentType
                            : data.posScreenStyles.paymentModal.paymtCard
                        }
                        tabIndex={0}
                        onKeyPress={(e) => (e.charCode === 13 ? setSelectedPaymentMethod(pm) : null)}
                      >
                        {pm.name}
                      </button>
                    </Col>
                  );
                })}
              </Row>

              {/* Amount input */}
              <Row style={{ paddingBottom: "6vh" }}>
                <Col span={24}>
                  <Input
                    size="large"
                    allowClear={false}
                    readOnly={posConfig?.allowSplitTender === "N" ? true : false}
                    style={data.posScreenStyles.orderHistoryModal.paymentSearchInput}
                    value={amount}
                    onChange={onChangeAmount}
                    ref={paymentModalInputRef}
                    placeholder="Enter Amount"
                    className="totalInput"
                    disabled={tillData.tillAccess.cwrTill.layAway === "Y" && tillData.tillAccess.cwrTill.payNow === "N" ? true : false}
                    onPressEnter={
                      parseFloat(cart.total) > parseFloat(cart.paid) && cart.payments.length > 0
                        ? () => requestPayment(selectedPaymentMethod, amount)
                        : () => processOrder()
                    }
                  />
                </Col>
              </Row>

              {/* Numpad */}
              <Row gutter={[0, 16]}>
                <Col span={1} />
                <Col span={22}>
                  <Row gutter={[10, 8]}>
                    {["1", "2", "3", "x", "4", "5", "6", ".", "7", "8", "9", "0"].map((key) => (
                      <Col span={6} key={key}>
                        <button className="amt-dial-btn" onClick={() => handleAmount(key)}>
                          {key === "x" ? (
                            <img src={CancelArrow} alt="back space" width={width <= 1024 ? 20 : 30} height={width <= 1024 ? 15 : 20} />
                          ) : (
                            key
                          )}
                        </button>
                      </Col>
                    ))}
                  </Row>
                </Col>
              </Row>
            </div>
            <div style={{ width: "18.5%" }} />
          </div>
        </div>

        {/* RIGHT SIDE — payment cart summary */}
        <div style={{ borderLeft: "1px solid rgba(0, 0, 0, 0.14)", width: "32.2%", backgroundColor: "#fff" }}>
          <Row style={{ padding: "6px 10px 10px 10px", height: "100vh" }}>
            <Col span={24} style={{ paddingTop: "1.7vh" }}>
              <Row>
                <Col span={9} className="cartStyle">
                  <span>CART</span>
                  <span style={{ fontSize: "1vw", paddingLeft: "0.5vw", paddingBottom: "0.3vw", color: "rgba(0, 0, 0, 0.35)", fontWeight: "600" }}>
                    {cart.totalQty} Item(s)
                  </span>
                </Col>
                <Col span={10} />
              </Row>
              <Row style={{ paddingTop: "8px", height: "91.6vh" }}>
                <Col span={24}>
                  <div style={data.posScreenStyles.cardDetails} styles={{ body: { padding: 0, backgroundColor: "red" } }}>
                    <Table
                      className="cart-table"
                      style={data.posScreenStyles.cartTable.tableStl}
                      pagination={false}
                      dataSource={[...cart.items]}
                      sticky
                      scroll={{ y: cart.payments.length > 0 ? "50vh" : "60vh" }}
                      rowClassName="tableRowNonSelectedWhite"
                      columns={[
                        {
                          title: "Item name",
                          dataIndex: "name",
                          key: "name",
                          width: "55%",
                          render: (text, record) => (
                            <>
                              <div
                                onClick={() => {
                                  selectProductInCart(record, "1");
                                  setIsSearchProducts(false);
                                  if (selectedRowKeys.length > 0 && selectedProductInCart.productId === record.productId) {
                                    setIsQtyUpdate(true);
                                  }
                                }}
                                className="productName1"
                              >
                                {record.name}
                                {record.selectedAddons &&
                                  record.selectedAddons.length > 0 &&
                                  record.selectedAddons.map((item, idx) => {
                                    return (
                                      item?.name && (
                                        <p key={idx} style={{ margin: 0, padding: 0, color: "#8c92ac", fontStyle: "italic", fontSize: "0.85em" }}>
                                          {item.name}
                                        </p>
                                      )
                                    );
                                  })}
                              </div>
                              <div className="offerName">
                                {cart.discount > 0 ? record.discountName || "" : ""}{" "}
                                {cart.discount > 0 ? record.discountName ? <img src={Offers} alt="" width={15} height={15} style={{ marginTop: "-2px" }} /> : "" : ""}
                              </div>
                            </>
                          ),
                        },
                        {
                          title: "Qty",
                          dataIndex: "weight",
                          key: "weight",
                          width: "15%",
                          render: (text, record) => {
                            const wt = parseFloat(text);
                            if (Number.isInteger(wt)) {
                              return (
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                  <div style={{ margin: "0 3px", fontWeight: "500", fontSize: "0.9vw" }}>{wt}</div>
                                </div>
                              );
                            } else {
                              return (
                                <>
                                  <div>{parseFloat(text).toFixed(2)}</div>
                                  <div className="offerName">
                                    {record.salesRepName && posConfig?.showOrderSalesRep === "Y" && posConfig?.showLineSalesRep === "Y" ? record.salesRepName : ""}
                                  </div>
                                </>
                              );
                            }
                          },
                        },
                        {
                          title: "Amount",
                          dataIndex: "nettotal",
                          key: "nettotal",
                          render: (text) => (
                            <div>
                              {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                              &nbsp;
                              <span style={{ fontWeight: "500", fontSize: "0.9vw" }}>{parseFloat(text).toFixed(prcPrecision)}</span>
                              &nbsp;
                              {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                            </div>
                          ),
                          align: "right",
                        },
                      ]}
                      onRow={(record) => ({
                        onDoubleClick: () => selectProductInCart(record),
                      })}
                    />
                    <div style={data.posScreenStyles.cartTable.prodTotal}>
                      <div style={{ padding: "1% 1.5%", borderTop: cart.payments.length > 0 ? "1px solid rgba(0, 0, 0, 0.27)" : "" }}>
                        {cart.payments.map((item) => (
                          <Row style={{ paddingTop: "0.4vw" }}>
                            <Col span={12}>
                              <p style={{ textAlign: "left", margin: "0", fontWeight: "600", fontSize: "1.3vw" }}>{item.name}</p>
                              <p style={{ margin: "0", fontSize: "1vw" }}>{new Date().toLocaleDateString("zh-Hans-CN")}</p>
                            </Col>
                            <Col span={12}>
                              <p style={{ textAlign: "right", fontWeight: "600" }}>
                                {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                                &nbsp;{item.amount} {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                              </p>
                            </Col>
                          </Row>
                        ))}
                      </div>
                      <div style={{ backgroundColor: "#fff", borderTop: "1px dashed #929098" }}>
                        <Row style={{ padding: "0px 5px 0 5px", paddingTop: "3vh" }}>
                          <Col span={6} offset={1}>
                            <label style={data.posScreenStyles.cartTable.taxDisLbl} className="taxDisLbl">Tax</label>
                          </Col>
                          <Col span={16} style={data.posScreenStyles.cartTable.amtTextAlign}>
                            <label style={data.posScreenStyles.cartTable.taxDisLbl} className="taxDisLbl">
                              {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                              &nbsp;{parseFloat(cart.tax).toFixed(prcPrecision)}
                              <span style={{ marginLeft: "2px" }}>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span>
                            </label>
                          </Col>
                          <Col span={1} />
                        </Row>
                        <Row style={{ padding: "0px 5px 0 5px" }}>
                          <Col span={6} offset={1}>
                            <label style={data.posScreenStyles.cartTable.taxDisLbl} className="taxDisLbl">Discounts</label>
                          </Col>
                          <Col span={16} style={data.posScreenStyles.cartTable.amtTextAlign}>
                            <label style={data.posScreenStyles.cartTable.taxDisLbl} className="taxDisLbl">
                              {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                              &nbsp;{parseFloat(cart.discount).toFixed(prcPrecision)}
                              <span style={{ marginLeft: "2px" }}>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span>
                            </label>
                          </Col>
                          <Col span={1} />
                        </Row>
                        <Row style={{ padding: "0px 5px 0 5px" }}>
                          <Col span={6} offset={1}>
                            <label style={data.posScreenStyles.cartTable.taxDisLbl} className="taxDisLbl">Items / Qty</label>
                          </Col>
                          <Col span={16} style={data.posScreenStyles.cartTable.amtTextAlign}>
                            <label style={data.posScreenStyles.cartTable.taxDisLbl} className="taxDisLbl">
                              &nbsp;{cart.items.length} / {parseFloat(cart.totalQty).toFixed(2)}
                            </label>
                          </Col>
                          <Col span={1} />
                        </Row>
                        <Row style={{ padding: "0px 5px 0 5px" }}>
                          <Col span={12} offset={1}>
                            <label style={data.posScreenStyles.cartTable.taxTotal} className="taxDisLbl">Total Amount</label>
                          </Col>
                          <Col span={10} style={data.posScreenStyles.cartTable.amtTextAlign}>
                            <label style={data.posScreenStyles.cartTable.taxTotal} className="taxDisLbl">
                              {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                              &nbsp;{parseFloat(cart.total).toFixed(prcPrecision)}
                              <span style={{ marginLeft: "2px" }}>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span>
                            </label>
                          </Col>
                          <Col span={1} />
                        </Row>
                        <Row style={{ padding: "1.4vh 0.14vh 0.7vh 1.4vh", display: "flex", justifyContent: "center", paddingTop: "1.5vh" }}>
                          {tillData.tillAccess.cwrTill.payNow === "Y" ? (
                            <Button
                              size="large"
                              onClick={
                                parseFloat(cart.total) > parseFloat(cart.paid)
                                  ? () => (posConfig?.enableCash === "N" && posConfig?.enableCard === "N" ? "" : requestPayment(selectedPaymentMethod, amount))
                                  : () => processOrder()
                              }
                              className="totalBtn"
                              style={data.posScreenStyles.cartTable.totalBtn}
                            >
                              {cart.items.length !== 0
                                ? parseFloat(cart.total) > parseFloat(cart.paid)
                                  ? paymentModalLoyalityMessages.buttonText
                                  : "Complete Order"
                                : "Payment Not Allowed !"}
                            </Button>
                          ) : null}
                          {tillData.tillAccess.cwrTill.layAway === "Y" ? (
                            <Button size="large" onClick={() => processOrder("layaway")} className="totalBtn" style={data.posScreenStyles.cartTable.totalBtn}>
                              {cart.items.length !== 0 ? "Layaway" : "Operation Not Allowed !"}
                            </Button>
                          ) : null}
                          {cart?.creditSale === "Y" ? (
                            <Button size="large" onClick={() => processOrder("layaway")} className="totalBtn" style={{ ...data.posScreenStyles.cartTable.totalBtn, backgroundColor: "#2F3856" }}>
                              {cart.items.length !== 0 ? "Credit Sale" : "Operation Not Allowed !"}
                            </Button>
                          ) : null}
                        </Row>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </div>
    );
  }

  // Payment success / receipt view
  return (
    <div style={{ padding: "3%", width: "100%", backgroundColor: "#F3F4F9", height: "100vh" }}>
      <Row style={{ position: "absolute", top: "3%", left: "3%" }}>
        <Col span={8}>
          <img src={Logo} style={{ height: "4.5vw" }} onClick={handleBack} />
        </Col>
      </Row>
      <Row id="step1" justify="center" align="center" style={{ paddingBottom: "24px", width: "100%" }} gutter={[16, 16]}>
        <Col span={12} style={{ paddingRight: "0.3%", height: "90vh" }}>
          <div style={{ height: "100%", padding: "3% 4.5% 3% 6%", borderRadius: "8px", display: "flex", justifyContent: "center", flexDirection: "column" }}>
            <p style={{ color: "#000", fontSize: "2vw", fontWeight: "600", textAlign: "center", margin: 0, paddingBottom: "3vh" }}>Payment Successful</p>
            <Scrollbars className="itemScroll">
              {cart.items.map((item) => (
                <Row style={{ paddingTop: "1.8%", paddingBottom: "1.57%", borderBottom: "1px solid rgba(0, 0, 0, 0.11)" }}>
                  <Col span={16} style={{ paddingLeft: "1vw" }}>
                    <p style={{ fontWeight: "600", fontSize: "1.1vw" }}>{item.name}</p>
                    <div className="offerName1">
                      {cart.discount > 0 ? item.discountName || "" : ""}{" "}
                      {cart.discount > 0 ? item.discountName ? <img src={Offers} alt="" width={15} height={15} style={{ marginTop: "-2px" }} /> : "" : ""}
                    </div>
                  </Col>
                  <Col span={4}>
                    <p style={{ textAlign: "center", fontWeight: "600", fontSize: "1.1vw" }}>{item.weight}</p>
                  </Col>
                  <Col span={4}>
                    <p style={{ textAlign: "right", fontWeight: "600", fontSize: "1.1vw" }}>
                      {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                      &nbsp;{item.salePrice} {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                    </p>
                  </Col>
                </Row>
              ))}
            </Scrollbars>

            <Row style={{ paddingTop: "2%", borderTop: "1px solid rgba(0, 0, 0, 0.27)", paddingLeft: "1.5%" }}>
              <Col span={12}><h4 className="payment-details">Tax</h4></Col>
              <Col span={12}>
                <h4 style={{ textAlign: "right" }} className="payment-details">
                  {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                  &nbsp;{parseFloat(cart.tax).toFixed(prcPrecision)} {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                </h4>
              </Col>
              <Col span={12}><h4 className="payment-details">Discounts</h4></Col>
              <Col span={12}>
                <h4 style={{ textAlign: "right" }} className="payment-details">
                  {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                  &nbsp;{cart.discount} {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                </h4>
              </Col>
              <Col span={12}><h4 style={{ textAlign: "left" }} className="payment-details">Items / Qty</h4></Col>
              <Col span={12}>
                <h4 style={{ textAlign: "right" }} className="payment-details">
                  {cart.items.length} / {parseFloat(cart.totalQty).toFixed(2)}
                </h4>
              </Col>
            </Row>
            <Row style={{ borderTop: "1px solid rgba(0, 0, 0, 0.27)", padding: "2% 0 2% 1.5%", borderBottom: "1px solid rgba(0, 0, 0, 0.27)" }}>
              <Col span={12}><label style={{ fontSize: "2.1vw", fontWeight: "600" }}>Total</label></Col>
              <Col span={12} style={{ textAlign: "right" }}>
                <label style={{ fontSize: "2.1vw", fontWeight: "600", textAlign: "right" }}>
                  {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                  &nbsp;{cart.total} {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                </label>
              </Col>
            </Row>
            <div
              style={{
                paddingTop: "1%",
                borderTop: "1px solid rgba(0, 0, 0, 0.27)",
                paddingLeft: "1.5%",
                borderBottom: cart.payments.length > 30 ? "1px solid rgba(0, 0, 0, 0.27)" : "",
              }}
            >
              {cart.payments.map((item) => (
                <Row style={{ paddingTop: "0.4vw" }}>
                  <Col span={12}>
                    <p style={{ textAlign: "left", margin: "0", fontWeight: "600", fontSize: "1.3vw" }}>{item.name}</p>
                    <p style={{ margin: "0", fontSize: "1vw" }}>{new Date().toLocaleDateString("zh-Hans-CN")}</p>
                  </Col>
                  <Col span={12}>
                    <p style={{ textAlign: "right", fontWeight: "600" }}>
                      {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                      &nbsp;{item.amount} {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                    </p>
                  </Col>
                </Row>
              ))}
            </div>
          </div>
        </Col>
        <Col
          span={11}
          offset={1}
          style={{ paddingRight: "2%", height: "90vh", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "#fff", borderRadius: "10px" }}
        >
          <Row>
            <Col span={24} style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
              <p style={{ fontWeight: "600", fontSize: "1.8vw", paddingBottom: "4vh" }}>How would you like your receipt ?</p>
              <Button
                id="step2"
                style={{
                  width: "95%", height: "6vh", fontSize: "1.2vw", borderColor: "#2F3856", borderRadius: "8px",
                  fontWeight: "500", backgroundColor: "#2F3856", color: "#fff", marginBottom: "4vh",
                }}
              >
                Print Receipt
              </Button>
              <Button
                id="step2"
                style={{
                  width: "95%", height: "6vh", fontSize: "1.2vw", borderColor: "#2F3856", borderRadius: "8px",
                  fontWeight: "500", backgroundColor: "#2F3856", color: "#fff", marginBottom: "4vh",
                }}
              >
                Digital Receipt
              </Button>
              <Button
                id="step2"
                style={{
                  width: "95%", height: "6vh", fontSize: "1.3vw", borderColor: "#f3f4f9", borderRadius: "8px",
                  fontWeight: "500", backgroundColor: "#f3f4f9", color: "#000",
                }}
              >
                New Order
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default React.memo(PaymentView);
